module.exports = __webpack_public_path__ + "img/blt-btn01.dd53ebfe.svg";